import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UnitConversionService } from '../services/unit-conversion-service';
import { WeightUnit } from '../enums/weight-unit';
import { DimensionUnit } from '../enums/dimension-unit';
import Global from '../store/global-selectors';

export const useAutoReadFromScale = (autoReadScale$, onScaleRead, isDisabled) => {
  const sellerUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const sellerDimensionUnit = useSelector(Global.selectSellerDefaultDimensionUnit);

  useEffect(() => {
    // this hook will run multiple times because the onReadScale reference will change because it both updates package and has a dependacy on it
    // but it won't cause us to stop and restart the auto read channel because it is sharing
    // the auto read observable that is passed in
    if (!autoReadScale$ || isDisabled) {
      return;
    }

    const subscription = autoReadScale$.subscribe((action) => {
      if (!action?.message?.weight) {
        return;
      }
      const convertedWeight = UnitConversionService.convertValue(action.message.weight, WeightUnit.Ounces.toLowerCase(), sellerUnit);
      const weightAndUnit = {
        value: convertedWeight,
        unit: sellerUnit,
      };

      let convertedDims = null;
      if (action.message.dimensions) {
        const dims = action.message.dimensions;
        convertedDims = {
          length: dims.length
            ? UnitConversionService.convertValue(dims.length, DimensionUnit.Inches.toLowerCase(), sellerDimensionUnit)
            : 0,
          width: dims.width ? UnitConversionService.convertValue(dims.width, DimensionUnit.Inches.toLowerCase(), sellerDimensionUnit) : 0,
          height: dims.height
            ? UnitConversionService.convertValue(dims.height, DimensionUnit.Inches.toLowerCase(), sellerDimensionUnit)
            : 0,
        };
      }

      const weightAndDims = {
        weight: weightAndUnit,
        dimensions: convertedDims,
      };

      onScaleRead(weightAndDims);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [onScaleRead, sellerUnit, sellerDimensionUnit, autoReadScale$, isDisabled]);
};
